/**
 * Etch Viewport Configuration
 *
 * Per-product-type etch zone positioning (mirrors getCustomElementStyles() in
 * index.js) plus focus-camera framing for the Custom Studio zoom.
 *
 * NOTE: these values are tuned to the RETAIL product photos. On the wholesale
 * store's photo set the focus origins / zone boxes may need per-product QA.
 */

export const VIEWPORT_CONFIG = {
  'traveler-40oz': {
    etchZone: { width: '33%', height: '35%', top: '15%' },
    focus: { transformOrigin: '50% 32%', scaleDesktop: 1.8, scaleMobile: 1.4 },
  },
  'traveler-32oz': {
    etchZone: { width: '27%', height: '39.5%', top: '20%' },
    focus: { transformOrigin: '50% 39%', scaleDesktop: 2.0, scaleMobile: 1.5 },
  },
  'traveler-20oz': {
    etchZone: { width: '22%', height: '27%', top: '35%' },
    focus: { transformOrigin: '50% 48%', scaleDesktop: 2.2, scaleMobile: 1.6 },
  },
  'coffee-travelers': {
    etchZone: { width: '22%', height: '27%', top: '35%' },
    focus: { transformOrigin: '50% 48%', scaleDesktop: 2.2, scaleMobile: 1.6 },
  },
  'sport-40oz': {
    etchZone: { width: '27%', height: '38.5%', top: '17%' },
    focus: { transformOrigin: '50% 36%', scaleDesktop: 1.9, scaleMobile: 1.4 },
  },
  'sport-32oz': {
    etchZone: { width: '21%', height: '35.2%', top: '23%' },
    focus: { transformOrigin: '50% 40%', scaleDesktop: 2.2, scaleMobile: 1.6 },
  },
  'sport-20oz': {
    etchZone: { width: '19%', height: '29.3%', top: '34%' },
    focus: { transformOrigin: '50% 48%', scaleDesktop: 2.4, scaleMobile: 1.7 },
  },
  'sport-14oz': {
    etchZone: { width: '24%', height: '28%', top: '41%' },
    focus: { transformOrigin: '50% 55%', scaleDesktop: 2.2, scaleMobile: 1.6 },
  },
  'stainless-64oz': {
    etchZone: { width: '33.5%', height: '47%', top: '42.5%' },
    focus: { transformOrigin: '50% 65%', scaleDesktop: 1.6, scaleMobile: 1.3 },
  },
  'can-coolers-slim': {
    etchZone: { width: '28%', height: '33%', top: '44%' },
    focus: { transformOrigin: '50% 60%', scaleDesktop: 2.0, scaleMobile: 1.5 },
  },
  'can-coolers-standard': {
    etchZone: { width: '28%', height: '33%', top: '51%' },
    focus: { transformOrigin: '50% 67%', scaleDesktop: 2.0, scaleMobile: 1.5 },
  },
  'can-cooler-16oz': {
    etchZone: { width: '29%', height: '34%', top: '41%' },
    focus: { transformOrigin: '50% 58%', scaleDesktop: 2.0, scaleMobile: 1.5 },
  },
  'everyday-tumbler-14oz': {
    etchZone: { width: '25%', height: '24%', top: '50%' },
    focus: { transformOrigin: '50% 62%', scaleDesktop: 2.2, scaleMobile: 1.6 },
  },
  'everyday-tumbler-20oz': {
    etchZone: { width: '27%', height: '26.5%', top: '40%' },
    focus: { transformOrigin: '50% 53%', scaleDesktop: 2.0, scaleMobile: 1.5 },
  },
  'insulated-shaker': {
    etchZone: { width: '19%', height: '29%', top: '42%' },
    focus: { transformOrigin: '50% 56%', scaleDesktop: 2.4, scaleMobile: 1.7 },
  },
  'ease2o-40oz': {
    etchZone: { width: '23%', height: '36%', top: '25%' },
    focus: { transformOrigin: '50% 43%', scaleDesktop: 1.9, scaleMobile: 1.4 },
  },
  'ease2o-32oz': {
    etchZone: { width: '21%', height: '34%', top: '28%' },
    focus: { transformOrigin: '50% 45%', scaleDesktop: 2.1, scaleMobile: 1.5 },
  },
  'ease2o-24oz': {
    etchZone: { width: '19%', height: '30%', top: '36%' },
    focus: { transformOrigin: '50% 51%', scaleDesktop: 2.2, scaleMobile: 1.6 },
  },
  'ease2o-14oz': {
    etchZone: { width: '21%', height: '42%', top: '46%' },
    focus: { transformOrigin: '50% 67%', scaleDesktop: 2.2, scaleMobile: 1.6 },
  },
};

/** Lookup with fallback to a reasonable default */
export function getViewportConfig(productType) {
  return (
    VIEWPORT_CONFIG[productType] ?? {
      etchZone: { width: '30%', height: '35%', top: '25%' },
      focus: { transformOrigin: '50% 42%', scaleDesktop: 1.8, scaleMobile: 1.4 },
    }
  );
}
